import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const ConfirmationDialog = ({ open, title, children, onAnswer, yes='כן', no='לא' }) => {

  const handleAnswer = (answer) => {
    onAnswer(answer);
  };

  return (
    <Dialog open={open} onClose={() => handleAnswer(false)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleAnswer(false)} color="primary">
          {no}
        </Button>
        <Button onClick={() => handleAnswer(true)} color="secondary">
          {yes}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
